module.exports = __webpack_public_path__ + "static/media/gallery_15.a2fd9a3c.jpg";